"use strict";

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Menu = require("./Menu.style");

var _Dropdown = _interopRequireDefault(require("../../Dropdown"));

var _Link = _interopRequireDefault(require("../../Link"));

var _NavItem = _interopRequireDefault(require("../../NavItem"));

var Menu = function Menu(_ref) {
  var activeItem = _ref.activeItem,
      dropdownDirection = _ref.dropdownDirection,
      items = _ref.items,
      onItemClick = _ref.onItemClick,
      onItemHoverEnd = _ref.onItemHoverEnd,
      onItemHoverStart = _ref.onItemHoverStart,
      pathname = _ref.pathname,
      menuTitle = _ref.menuTitle,
      rest = _objectWithoutProperties(_ref, ["activeItem", "dropdownDirection", "items", "onItemClick", "onItemHoverEnd", "onItemHoverStart", "pathname", "menuTitle"]);

  if (!items || items.length === 0) {
    return null;
  }

  var animationStates = {
    rest: {
      opacity: 0,
      width: 0
    },
    active: {
      opacity: 1,
      width: '3.2rem'
    }
  };
  return /*#__PURE__*/_react.default.createElement(_Menu.Wrapper, Object.assign({}, rest, {
    role: "navigation",
    "aria-label": menuTitle
  }), /*#__PURE__*/_react.default.createElement(_Menu.UnstyledList, null, items.map(function (item) {
    var hasSubNav = item.navItems && item.navItems.length > 0;
    var isActiveItem = pathname === item.url || activeItem === item.label;
    var navItemProps = {
      animate: isActiveItem ? 'active' : 'rest',
      initial: isActiveItem ? 'active' : 'rest',
      whileHover: 'active'
    };

    var handleMoreItemClick = function handleMoreItemClick(e) {
      e.stopPropagation();
      item.onClick();
      onItemClick();
    };

    return hasSubNav ? /*#__PURE__*/_react.default.createElement("li", {
      key: item.label
    }, /*#__PURE__*/_react.default.createElement(_Menu.MenuItem, Object.assign({
      onHoverStart: function onHoverStart() {
        return onItemHoverStart(item.label);
      },
      onHoverEnd: function onHoverEnd() {
        return onItemHoverEnd(item.label);
      },
      onClick: function onClick() {
        return onItemHoverStart(item.label);
      }
    }, navItemProps), item.label, /*#__PURE__*/_react.default.createElement(_Menu.ActiveIndicator, {
      variants: animationStates
    }), /*#__PURE__*/_react.default.createElement(_Dropdown.default, {
      direction: dropdownDirection,
      isOpened: activeItem === item.label,
      items: item.navItems
    }, hasSubNav && item.navItems.map(function (navItem) {
      var handleItemClick = function handleItemClick(e) {
        e.stopPropagation();
        navItem.onClick();
        onItemClick();
      };

      return /*#__PURE__*/_react.default.createElement(_Link.default, {
        key: navItem.label,
        to: navItem.url,
        onClick: handleItemClick
      }, /*#__PURE__*/_react.default.createElement(_NavItem.default, {
        description: navItem.description,
        label: navItem.label
      }));
    }), item.url && /*#__PURE__*/_react.default.createElement(_Link.default, {
      to: item.url,
      onClick: handleMoreItemClick
    }, /*#__PURE__*/_react.default.createElement(_NavItem.default, {
      label: "More about ".concat(item.label)
    }))))) : /*#__PURE__*/_react.default.createElement("li", {
      key: item.label
    }, /*#__PURE__*/_react.default.createElement(_Link.default, {
      to: item.url
    }, /*#__PURE__*/_react.default.createElement(_Menu.MenuItem, Object.assign({
      active: item.url === pathname,
      onClick: item.onClick
    }, navItemProps), item.label, /*#__PURE__*/_react.default.createElement(_Menu.ActiveIndicator, {
      variants: animationStates
    }))));
  })));
};

Menu.propTypes = {
  activeItem: _propTypes.default.string,
  dropdownDirection: _propTypes.default.oneOf(['left', 'right']),
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string,
    description: _propTypes.default.string,
    navItems: _propTypes.default.arrayOf(_propTypes.default.shape({
      label: _propTypes.default.string,
      url: _propTypes.default.string
    }))
  })),
  onItemClick: _propTypes.default.func,
  onItemHoverEnd: _propTypes.default.func,
  onItemHoverStart: _propTypes.default.func,
  pathname: _propTypes.default.string,
  menuTitle: _propTypes.default.string
};
Menu.defaultProps = {
  activeItem: null,
  dropdownDirection: 'left',
  items: [],
  onItemClick: function onItemClick() {},
  onItemHoverEnd: function onItemHoverEnd() {},
  onItemHoverStart: function onItemHoverStart() {},
  pathname: '',
  menuTitle: 'menu'
};
var _default = Menu;
exports.default = _default;